import Vue from 'vue'

export default {

  state: Vue.observable({
    invoices: [],
    invoice: {},

    statuses: [],
  }),

  setInvoice(invoice) {
    this.state.invoice = invoice
  },
  
  setInvoices(invoices) {
    this.state.invoices = invoices
  },

  updateInvoice(newInvoice) {
    this.state.invoices = this.state.invoices.map(invoice => {
      return invoice.id == newInvoice.id ? newInvoice : invoice
    })
  },

  //
  setStatuses(statuses) {
    this.state.statuses = statuses
  },
}
